import React from 'react';
import PropTypes from 'prop-types';
import Col from 'reactstrap/lib/Col';
import { get } from 'lodash-es';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { InventoryModel } from 'client/data/models/inventory';
import { Spinner } from 'site-modules/shared/components/spinner/spinner';
import { Collapse } from 'site-modules/shared/components/collapse/collapse';

import './upgrade-description.scss';

export function UpgradeDescriptionUI({ optionDescription = null, optionId, isOpen = false }) {
  // while call is being made
  if (!optionDescription) {
    return <Spinner color="gray" size={20} className="mt-0_75 mx-1_5" />;
  }

  const description = get(optionDescription, `${optionId}.description`);

  if (!description) return null;

  return (
    <Collapse isOpen={isOpen} addState transition="height 280ms cubic-bezier(0.4, 0, 0.2, 1)">
      <Col xs={12} id={optionId} className="mt-0_5 medium p-0">
        <ul className="option-description p-0 mb-0 ps-1">
          {description.split(';').map((descriptionItem, index) => {
            const key = `${optionId}-item-${index}`;
            return (
              <li key={key} className="mb-0_5">
                {descriptionItem}
              </li>
            );
          })}
        </ul>
      </Col>
    </Collapse>
  );
}

UpgradeDescriptionUI.propTypes = {
  optionDescription: PropTypes.objectOf(
    PropTypes.shape({
      description: PropTypes.string,
    })
  ),
  optionId: PropTypes.number.isRequired,
  isOpen: PropTypes.bool,
};

export const stateToPropsConfig = {
  optionDescription: bindToPath(({ vin }) => `optionDescription["${vin}"]`, InventoryModel),
};

export const UpgradeDescription = connectToModel(UpgradeDescriptionUI, stateToPropsConfig);

UpgradeDescription.propTypes = {
  vin: PropTypes.string.isRequired,
};
